import * as constAction from 'root/actionConstants';

export const clear = value => ({
  type: constAction.ROLES_CLEAR,
  payload: value,
});

export const setState = payload => ({
  type: constAction.ROLES_SET_STATE,
  payload: payload,
});

export const get = () => ({
  type: constAction.ROLES_GET_ALL,
  epic: {
    url: 'usuarios/getAllRoles',
    method: 'GET',
  },
});

export const set = (userId, roles) => ({
  type: constAction.ROLES_SET,
  payload: { userId, roles },
  epic: {
    url: 'usuarios/cambiarRoles',
    method: 'POST',
  },
});

export const getRolesUser = userId => ({
  type: constAction.ROLES_GET_USER,
  payload: { userId },
  epic: {
    url: 'usuarios/getRolesUsuarios',
    method: 'POST',
  },
});



// WEBPACK FOOTER //
// src/modules/roles/action.js